import React, { useEffect, useState } from 'react';
import { Typography, Grid, Spin } from 'antd';

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

const API_BASE = process.env.REACT_APP_API_BASE || '';
const BRAND = 'var(--brand-primary, #222957)';

// 政策頁通用組件：服務政策 / 退換貨政策 / 隱私權政策 共用。
// 標題與內容由後台 /api/settings/shop 提供（key 由 props 指定），後台可編輯；
// 後台未填時顯示 defaultContent。內容以空白行分段。
export default function PolicyPage({ contentKey, titleKey, defaultTitle, defaultContent = '' }) {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState(defaultTitle);
  const [content, setContent] = useState('');

  useEffect(() => {
    let alive = true;
    setLoading(true);
    fetch(`${API_BASE}/api/settings/shop`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!alive) return;
        const t = d && d[titleKey];
        const c = d && d[contentKey];
        setTitle((t && String(t).trim()) || defaultTitle);
        setContent((c && String(c).trim()) || defaultContent);
      })
      .catch(() => { if (alive) setContent(defaultContent); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [contentKey, titleKey, defaultTitle, defaultContent]);

  const paragraphs = (content || '').split(/\n{2,}|\n/).map((s) => s.trim()).filter(Boolean);

  return (
    <div style={{ width: '100%', minHeight: '100%', background: isMobile ? '#fff' : '#F9FAFD' }}>
      <div style={{ maxWidth: 820, margin: '0 auto', padding: isMobile ? '24px 18px 40px' : '48px 32px 72px' }}>
        <Title level={isMobile ? 3 : 2} style={{ color: BRAND, fontWeight: 800, letterSpacing: 1, marginBottom: isMobile ? 20 : 28 }}>
          {title}
        </Title>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0' }}><Spin /></div>
        ) : paragraphs.length === 0 ? (
          <div style={{ color: '#8c8c8c' }}>內容尚未設定。</div>
        ) : (
          <div style={{
            background: '#F9FAFD', border: '1px solid #E5E7F5', borderRadius: 16,
            padding: isMobile ? '20px 18px' : '32px 36px',
          }}>
            {paragraphs.map((p, i) => (
              <Paragraph key={i} style={{ fontSize: isMobile ? 15 : 16, lineHeight: 2, color: '#2C3674', marginBottom: 16 }}>
                {p}
              </Paragraph>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
